// simple expandable details.
// requires element passed in the constructure to have the following structure
// where "details" must be the last-child of the element
// <div class="expandable-details"> ... <div class="details"> ... </div></div>

class ExpandableDetails {
  constructor(el) {
    this.el = el;
  }

  // -- HANDLERS -- //

  showStuff = evt => {
    this.el.classList.add("expanded");
  };

  // -- INIT -- //

  createShowButton = () => {
    // create a tag and copy
    const linkEl = document.createElement("a");
    linkEl.textContent = "Read more";

    // create wrapping p tag
    const showEl = document.createElement("p");
    showEl.classList.add("show-details");
    showEl.appendChild(linkEl);

    // add to doc
    this.el.appendChild(showEl);

    // activate
    showEl.addEventListener("click", this.showStuff);
  };

  init = () => {
    this.createShowButton();

    // set intial css state
    this.el.classList.add("closed");
  };
}

export default ExpandableDetails;
